import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcWasteBasis = DatabaseCode;

const labReports: RrcWasteBasis = {
  code: "LAB_REPORTS",
  displayValue: {
    id: "common.entity.rrcwastebasis.labreports",
    defaultMessage: "Lab Reports",
  },
};

const historicalData: RrcWasteBasis = {
  code: "HISTORICAL_DATA",
  displayValue: {
    id: "common.entity.rrcwastebasis.historicaldata",
    defaultMessage: "Historical Data",
  },
};

const processKnowledge: RrcWasteBasis = {
  code: "PROCESS_KNOWLEDGE",
  displayValue: {
    id: "common.entity.rrcwastebasis.processknowledge",
    defaultMessage: "Process Knowledge",
  },
};

export const rrcWasteBasis = {
  labReports,
  historicalData,
  processKnowledge,
};

export const rrcWasteBasisTypes: RrcWasteBasis[] = Object.values(rrcWasteBasis);

export const toRrcWasteBasis = (code: string): RrcWasteBasis =>
  toDatabaseCode(code, rrcWasteBasisTypes);

export const toRrcWasteBasisSafely = (
  code: string | undefined,
  defaultValue: RrcWasteBasis | undefined = undefined
): RrcWasteBasis | undefined => toDatabaseCodeSafely(code, rrcWasteBasisTypes, defaultValue);
